import React from 'react';

import './styles/searchBar.scss';

class InputItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFocus: false,
    };
  }

  handleFocus = event => {
    if (this.props.onFocus) {
      this.props.onFocus(event);
    }
    this.setState({ isFocus: true });
  };

  handleBlur = event => {
    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
    this.setState({ isFocus: false });
  };

  render() {
    return (
      <div className='input-container'>
        <input
          className='textfield-input'
          placeholder='Search by topic, show, or episode'
          onChange={this.props.onChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          data-hj-whitelist
        />
      </div>
    );
  }
}

export default InputItem;
